import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const ChevronUp = ({
  size,
  type,
  theme,
  className,
  dataTestId = "chevron-up-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.24116 10.3086C3.50151 10.569 3.92362 10.569 4.18397 10.3086L8.00035 6.49227L11.8167 10.3086C12.0771 10.569 12.4992 10.569 12.7595 10.3086C13.0199 10.0483 13.0199 9.62618 12.7595 9.36584L8.47175 5.07805C8.2114 4.8177 7.78929 4.8177 7.52894 5.07805L3.24116 9.36584C2.98081 9.62618 2.98081 10.0483 3.24116 10.3086Z"
    />
  </SVGIcon>
);
